module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"liked":"いいね！しました。","removed":"いいね！を外しました。","error_occurred":"エラーが発生しました。","are_you_sure_to_delete_this":"記事を削除してもよろしいですか？","deleted":"記事を削除しました。"}}')
  delete Component.options._Ctor
}
